import { Snowplow2StatsObserver } from './observer';
import { Snowplow2StatsTrackerFactory } from './tracker.factory';

export function Snowplow2StatsObserverFactory(): Snowplow2StatsObserver {
  return new Snowplow2StatsObserver(Snowplow2StatsTrackerFactory());
}
